<template>
	<v-expansion-panels v-if="clusters.length > 0" v-model="expanded">
		<v-expansion-panel class="widget-builder--panel" eager>
			<v-expansion-panel-title>
				<v-icon>hub</v-icon>
				{{ label || t('KpiByCluster') }}
				<v-badge color="primary" :content="clusters.length" inline></v-badge>
			</v-expansion-panel-title>
			<v-expansion-panel-text>
				<transition-group name="pop" tag="div" class="kpi-list">
					<div class="custom-kpi" v-for="cluster in clusters" :key="cluster.key">
						<Kpi :title="cluster.title" :color="color" :width="width" :params="cluster.params" :static-data="cluster.staticData || null" :annotation="cluster.annotation" :need-title="false" :show-difference="true" />
					</div>
				</transition-group>
			</v-expansion-panel-text>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script setup>
import { ref } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import Kpi from '@/components/kpi/Kpi.vue';

const t = useTranslator();

const props = defineProps({
	clusters: { type: Array, default: () => [] },
	label: { type: String, default: '' },
	color: { type: String, default: 'primary' },
	width: { type: Number, default: 12 },
	open: { type: Boolean, default: false },
});

const expanded = ref(props.open ? 0 : undefined);
</script>
